<template>
  <div id="app" :class="this.getTheme " class="theme-dark transition">
    <router-view class=" w-screen h-screen"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({}),
  computed: {
    ...mapGetters({
      getTheme: 'theme/color'
    })
  },
  methods: {},
  created () {
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;600&family=Open+Sans&display=swap');

#app {
  font-family: 'Poppins', sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.transition {
  transition: all ease-in .6s;
}

.maven_pro {
  font-family: 'Maven Pro', sans-serif;
}

/*#nav {*/
/*  padding: 30px;*/
/*}*/

/*#nav a {*/
/*  font-weight: bold;*/
/*  color: #2c3e50;*/
/*}*/

/*#nav a.router-link-exact-active {*/
/*  color: #42b983;*/
/*}*/
</style>
